export function getUserDisplayName(user) {
  if (!user) return "";
  const full = String(user.full_name || "").trim();
  if (full) return full;
  const parts = `${user.first_name || ""} ${user.last_name || ""}`.trim();
  if (parts) return parts;
  return String(user.username || "").trim();
}

export function isAssignableRepRole(user) {
  if (!Array.isArray(user?.groups)) return false;
  return user.groups.some((g) => {
    const name = String(g?.name || g || "").toLowerCase();
    return name.includes("sales") || name.includes("manager");
  });
}

export function formatAssignedRepOptionLabel(user) {
  const name = getUserDisplayName(user) || "Unknown";
  return user?.is_active === false ? `${name} (Inactive)` : name;
}

/**
 * Active reps sorted A–Z by display name.
 * If the lead is already assigned to someone missing from that list
 * (typically inactive), keep that one option so the current value still shows.
 */
export function buildAssignedRepOptions({
  users = [],
  currentRepId = null,
  currentRepName = "",
  requireAssignableRole = true,
} = {}) {
  const parsedId = currentRepId != null && currentRepId !== ""
    ? Number(currentRepId)
    : null;
  const validCurrentId = Number.isFinite(parsedId) && parsedId > 0 ? parsedId : null;

  const eligible = (Array.isArray(users) ? users : []).filter((u) => {
    if (requireAssignableRole && !isAssignableRepRole(u)) return false;
    return true;
  });

  const options = eligible.filter((u) => u.is_active !== false);
  const hasCurrent = Boolean(
    validCurrentId && options.some((u) => Number(u.id) === validCurrentId)
  );

  if (validCurrentId && !hasCurrent) {
    const current = eligible.find((u) => Number(u.id) === validCurrentId);
    options.push(
      current || {
        id: validCurrentId,
        full_name: currentRepName || "Unknown",
        first_name: "",
        last_name: "",
        username: "",
        is_active: false,
      }
    );
  }

  return options.sort((a, b) =>
    getUserDisplayName(a).localeCompare(getUserDisplayName(b), undefined, {
      sensitivity: "base",
    })
  );
}
